import axios from 'axios'

export default {
    namespaced: true,

    state: {
        authenticated: sessionStorage.getItem('authenticated') || false,
        studentRecord: sessionStorage.getItem('student_record') || null,
        overlay: false,
        loginErrors: '',
        authToken: sessionStorage.getItem('auth_token') || null,
    },

    getters: {
        getAuthenticated (state) {
            return state.authenticated
        },
        getOverlay(state){
            return state.overlay
        },

        getStudentRecord(state){
            return state.studentRecord
        },

        getLoginErrors(state){
            return state.loginErrors
        },

        getAuthToken(state){
            return state.authToken
        },
    },

    mutations: {
        setAuthenticated (state, value) {
            state.authenticated = value
        },
        setOverlay (state, value){
            state.overlay = value
        },

        setStudentRecord(state, value){
            state.studentRecord = value
        },

        setLoginErrors(state, value){
            state.loginErrors = value
        },
        setAuthToken(state, value){
            state.authToken = value
        },
    },

    actions: {
        async signIn ({ commit }, credentials){ 
            commit('setOverlay', true);
            try{
                await axios.get('/sanctum/csrf-cookie')
                console.log("authenticating login credentials");
                const { data } = await axios.post('/api/login-student', credentials);
                
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.auth_token;
                
                sessionStorage.setItem('auth_token', data.auth_token);
                sessionStorage.setItem('authenticated', data.id);
                sessionStorage.setItem('student_record', JSON.stringify(data));
                
                commit('setAuthToken', data.auth_token);
                commit('setAuthenticated', data.id);
                commit('setStudentRecord', JSON.stringify(data));
                               
            } catch(error){
                console.log(error.response);
                commit('setLoginErrors', error.response.data.message);
                commit('setAuthenticated', false);
                commit('setOverlay', false); 
            }    
            
        },

        async signOut({commit}){                       
            await axios.post('/api/logout')
                    .then(response => {
                        console.log(response);
                    })
            return commit('setAuthenticated', false); 
        },
       
    }
}